export const inputsState = {
  website: '',
  linkedin: '',
  instagram: '',
  description: '',
  portfolioURL: '',
  problemSolves: '',
  competitiveDifferentiators: '',
};
